import { render, staticRenderFns } from "./SpecialTerms.vue?vue&type=template&id=0805fa3a&scoped=true&"
import script from "./SpecialTerms.vue?vue&type=script&lang=js&"
export * from "./SpecialTerms.vue?vue&type=script&lang=js&"
import style0 from "./SpecialTerms.vue?vue&type=style&index=0&id=0805fa3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0805fa3a",
  null
  
)

export default component.exports